export const validateZipCode = (value: string): boolean => {
  const pattern = /^\d{5}$|^\d{5}-\d{4}$/

  return pattern.test(value)
}

export const validateSSN = (value: string): boolean => {
  const environment = process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF

  if (!environment || environment === 'main') {
    const pattern = /^(?!(000|666))(\d{3}-?(?!(00))\d{2}-?(?!(0000))\d{4})$/
    return pattern.test(value)
  } else {
    const pattern = /^\d{3}-\d{2}-\d{4}$/
    return pattern.test(value)
  }
}

export const validatePhoneNumber = (value: string): boolean => {
  const pattern = /^\d{3}-\d{3}-\d{4}$/

  return pattern.test(value)
}

export const validatePassword = (password: string) => {
  const lengthRegex = new RegExp('^(?=.{8,})')
  const specialChaRegex = new RegExp('^(?=.*[!@#$%^&*])')
  const numericRegex = new RegExp('^(?=.*[0-9])')
  const uppercaseRegex = new RegExp('^(?=.*[A-Z])')
  const lowercaseRegex = new RegExp('^(?=.*[a-z])')

  const isValidPassword = new RegExp(
    '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})'
  )

  return {
    hasLowercase: lowercaseRegex.test(password),
    hasUppercase: uppercaseRegex.test(password),
    hasSpecialCharacter: specialChaRegex.test(password),
    hasNumeric: numericRegex.test(password),
    hasValidLength: lengthRegex.test(password),
    isValid: isValidPassword.test(password),
  }
}
